import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeftRight } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuInput, NeuSelect } from "../../components/neu/Neu";
import { fxConvert } from "../../api/fx";
import { useApiError } from "../../hooks/useApiError";

const CODES = ["IQD", "USD", "AED", "SAR", "JOD", "KWD", "EUR", "GBP", "TRY", "INR"];

// حاسبة سريعة للتأكد من السعر المشتق قبل استخدامه في القيود.
export const FxConverter = () => {
  const { t } = useTranslation();
  const describe = useApiError();
  const [form, setForm] = useState({ amount: "1000", from_currency: "AED", to_currency: "IQD" });
  const [result, setResult] = useState(null);

  const run = async () => {
    try {
      setResult(await fxConvert({ ...form, amount: Number(form.amount) }));
    } catch (error) {
      toast.error(describe(error));
    }
  };

  const set = (key) => (event) => setForm({ ...form, [key]: event.target.value });

  return (
    <div className="grid gap-3 rounded-2xl p-4 shadow-neu-in" data-testid="fx-converter">
      <p className="label-xs">{t("fx.converter")}</p>
      <div className="grid gap-3 sm:grid-cols-4">
        <NeuInput type="number" data-testid="fx-amount" value={form.amount} onChange={set("amount")} />
        <NeuSelect data-testid="fx-from" value={form.from_currency} onChange={set("from_currency")}>
          {CODES.map((code) => <option key={code} value={code}>{code}</option>)}
        </NeuSelect>
        <NeuSelect data-testid="fx-to" value={form.to_currency} onChange={set("to_currency")}>
          {CODES.map((code) => <option key={code} value={code}>{code}</option>)}
        </NeuSelect>
        <NeuButton data-testid="fx-convert" onClick={run}>
          <ArrowLeftRight className="h-4 w-4" /> {t("fx.convert")}
        </NeuButton>
      </div>
      {result ? (
        <p className="font-mono text-sm font-bold" dir="ltr" data-testid="fx-result">
          {result.original_amount} {result.original_currency} = {result.converted_amount} {result.converted_currency}
          {"  "}
          <span className="text-[11px] font-semibold text-muted-foreground">
            @ {Number(result.exchange_rate).toFixed(6)} · IQD {result.amount_iqd}
          </span>
        </p>
      ) : null}
    </div>
  );
};
